'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Link from 'next/link';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Logo } from '@/icons/logo';
import { usePathname } from 'next/navigation';
import { useSession } from 'next-auth/react';
export const Navbar = () => {
  const $ = _c(34);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const pathname = usePathname();
  const isHomePage = pathname === "/";
  const session = useSession();
  const isAuthenticated = !!session?.data?.user;
  const ctaCopy = isAuthenticated ? "Dashboard" : "Try now";
  const ctaLink = isAuthenticated ? "/dashboard" : "/login";
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Link href="/" className="flex items-center gap-1"><Logo width={32} height={32} /><h6 className="text-xl font-semibold tracking-tighter text-[#21300E]">Gardenly</h6></Link>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = isHomePage ? "#how-it-works" : "/#how-it-works";
  let t2;
  if ($[1] !== t1) {
    t2 = <Link href={t1} className="text-sm text-gray-600 transition-colors hover:text-[#21300E]">How it works</Link>;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = isHomePage ? "#pricing" : "/#pricing";
  let t4;
  if ($[3] !== t3) {
    t4 = <Link href={t3} className="text-sm text-gray-600 transition-colors hover:text-[#21300E]">Pricing</Link>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = isHomePage ? "#reviews" : "/#reviews";
  let t6;
  if ($[5] !== t5) {
    t6 = <Link href={t5} className="text-sm text-gray-600 transition-colors hover:text-[#21300E]">Reviews</Link>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Link href="/blog" className="text-sm text-gray-600 transition-colors hover:text-[#21300E]">Blog</Link>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t2 || $[9] !== t4 || $[10] !== t6) {
    t8 = <div className="flex items-center gap-20">{t0}<nav className="hidden items-center space-x-8 md:flex">{t2}{t4}{t6}{t7}</nav></div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t6;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== ctaCopy || $[13] !== ctaLink) {
    t9 = <div className="hidden items-center space-x-2 md:flex"><Button asChild={true}><Link href={ctaLink}>{ctaCopy}</Link></Button></div>;
    $[12] = ctaCopy;
    $[13] = ctaLink;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isMenuOpen) {
    t10 = () => setIsMenuOpen(!isMenuOpen);
    $[15] = isMenuOpen;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== isMenuOpen) {
    t11 = isMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />;
    $[17] = isMenuOpen;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11) {
    t12 = <div className="md:hidden"><button onClick={t10} className="text-gray-600 hover:text-[#21300E]">{t11}</button></div>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t8 || $[24] !== t9) {
    t13 = <div className="container mx-auto px-4"><div className="flex h-16 items-center justify-between">{t8}{t9}{t12}</div></div>;
    $[22] = t12;
    $[23] = t8;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== ctaCopy || $[27] !== ctaLink || $[28] !== isHomePage || $[29] !== isMenuOpen) {
    t14 = isMenuOpen && <div className="border-b border-gray-100 bg-white md:hidden"><div className="container mx-auto p-4"><nav className="flex flex-col space-y-4"><Link href={isHomePage ? "#how-it-works" : "/#how-it-works"} className="py-2 text-gray-600 transition-colors hover:text-[#21300E]" onClick={() => setIsMenuOpen(false)}>How it works</Link><Link href={isHomePage ? "#pricing" : "/#pricing"} className="py-2 text-gray-600 transition-colors hover:text-[#21300E]" onClick={() => setIsMenuOpen(false)}>Pricing</Link><Link href={isHomePage ? "#reviews" : "/#reviews"} className="py-2 text-gray-600 transition-colors hover:text-[#21300E]" onClick={() => setIsMenuOpen(false)}>Reviews</Link><Link href="/blog" className="py-2 text-gray-600 transition-colors hover:text-[#21300E]">Blog</Link><div className="mt-4 border-t border-gray-200 pt-4"><Button asChild={true} className="w-full"><Link href={ctaLink}>{ctaCopy}</Link></Button></div></nav></div></div>;
    $[26] = ctaCopy;
    $[27] = ctaLink;
    $[28] = isHomePage;
    $[29] = isMenuOpen;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <header className="sticky top-0 z-50 bg-white/90 backdrop-blur-lg">{t13}{t14}</header>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};